/**
 * Created by Mark on 18/12/2016.
 */

import ApplicationServices from './base-service.js';
import Constants from '../constants.js';
import Action    from '../application-actions.js';

class UserService {


    updatePassword(userUid){
        return ApplicationServices.call(Constants.UPDATE_PERSONAL_PASSWORD , {userUid:userUid}).then(function(response){
            return response
        })
    }

    make(title , displayName , firstName ,lastName  , email , userType){
        return ApplicationServices.call(Constants.MAKE_STAFF_MEMBER , {email:email , userType:userType , lastName:lastName  ,firstName:firstName , title:title , displayName:displayName}).then(function(response){
            return response
        })
    };

    emailExsit(email){
       return ApplicationServices.call(Constants.GET_DOES_EMAIL_EXIST , {email:email}).then(function(response){
            return !response.isValid
        })
    };

    getPersonal(){
        ApplicationServices.call(Constants.GET_PERSONAL_INFROMATION , {}).then(function(response){

            Action.update(Constants.GET_PERSONAL_INFROMATION , response.user);
        })
    }

    updatePersonal(fields){
        return ApplicationServices.call(Constants.UPDATE_PERSONAL_INFROMATION , {fields:fields}).then(function(response){
            Action.update(Constants.UPDATE_PERSONAL_INFROMATION , response.user);
        })
    }


    getFavAssignments(){
        return ApplicationServices.call(Constants.GET_ALL_FAV , {}).then(function(response){
            Action.update(Constants.GET_ALL_FAV , response.assignments);
        })
    }


    getAccounts(){
        ApplicationServices.call(Constants.GET_USER_ACCOUNTS , {}).then(function(response){
            Action.update(Constants.ON_ACCOUNTS_FETCH , response.accounts);
            return response.accounts
        });
    }

    isAdminRegistered(){
        ApplicationServices.call(Constants.GET_IS_REGISTERED , {}).then(function(response){
            Action.update(Constants.IS_ACCOUNT_REGISTERED , response);
        });
    }

    getAssignments(){
        ApplicationServices.call(Constants.GET_MY_ASSIGNMENTS , {}).then(function(response){
            Action.update(Constants.GET_MY_ASSIGNMENTS , response.homework);
        });
    }

    getArchivedAssignments(){
        ApplicationServices.call(Constants.GET_MY_ARCHIVED_ASSIGNMENTS , {}).then(function(response){
            Action.update(Constants.GET_MY_ARCHIVED_ASSIGNMENTS , response.homework);
        });
    }
}

export default new UserService();